module.exports = __webpack_public_path__ + "media/dashboard/assets/images/close-0d3cb7cd95c42b419c84a05e4e1bb025.svg";